import React from 'react'

/**
 * 协议选择器组件
 * 提供 http:// 和 https:// 协议选择，方便用户输入地址时选择协议
 * 
 * @param {Object} props - 组件属性
 * @param {string} props.value - 当前选中的协议值
 * @param {Function} props.onChange - 协议改变时的回调函数
 * @param {string} props.className - 额外的CSS类名
 * @param {boolean} props.disabled - 是否禁用
 */
const ProtocolSelector = ({ value = 'http://', onChange, className = '', disabled = false }) => {
  const protocols = [
    { value: 'http://', label: 'HTTP' },
    { value: 'https://', label: 'HTTPS' }
  ]

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`select ${className}`}
      disabled={disabled}
    >
      {protocols.map(protocol => (
        <option key={protocol.value} value={protocol.value}>
          {protocol.label}
        </option>
      ))}
    </select>
  )
}

export default ProtocolSelector
